/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Hero_SubInputs */

const en_cp_hero_sub = /** @type {(inputs: Cp_Hero_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A program for student teams who want to build a business or solve a real problem — from idea to PRD, tasks with pass/fail criteria, built with any AI coding agent, and approved by the lecturer phase by phase.`)
};

const id_cp_hero_sub = /** @type {(inputs: Cp_Hero_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Program untuk tim mahasiswa yang ingin membangun bisnis atau memecahkan masalah nyata — dari ide jadi PRD, task dengan kriteria lulus/gagal, dikerjakan dengan AI coding agent apa pun, dan disetujui dosen per fase.`)
};

/**
* | output |
* | --- |
* | "A program for student teams who want to build a business or solve a real problem — from idea to PRD, tasks with pass/fail criteria, built with any AI coding ..." |
*
* @param {Cp_Hero_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_hero_sub = /** @type {((inputs?: Cp_Hero_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Hero_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_hero_sub(inputs)
	return en_cp_hero_sub(inputs)
});